import { Game, GameStatus } from '../types';

// Public-facing status: games only show as In Repair / Awaiting Parts when the
// repair has been flagged severe. Routine repair flags stay internal.
export const publicStatus = (game: Game): GameStatus =>
  game.status !== 'Operational' && game.severeRepair ? game.status : 'Operational';
